// API Base URL
export const API_BASE_URL ='https://sales.visiontechnolabs.com/api';
export const APP_NAME = import.meta.env.VITE_APP_NAME || 'Manager Panel';

// Lead Status
export const LEAD_STATUS = {
  NEW: 'new',
  CONTACTED: 'contacted',
  FOLLOW_UP: 'follow_up',
  CONVERTED: 'converted',
  LOST: 'lost',
  CLOSED: 'closed',
};

export const LEAD_STATUS_LABELS = {
  new: 'New',
  contacted: 'Contacted',
  follow_up: 'Follow Up',
  converted: 'Converted',
  lost: 'Lost',
  closed: 'Closed',
};

export const LEAD_STATUS_COLORS = {
  new: 'primary',
  contacted: 'info',
  follow_up: 'warning',
  converted: 'success',
  lost: 'danger',
  closed: 'secondary',
};

// Lead Sources
export const LEAD_SOURCES = {
  WEBSITE: 'website',
  REFERRAL: 'referral',
  SOCIAL_MEDIA: 'social_media',
  EMAIL: 'email',
  PHONE: 'phone',
  WALK_IN: 'walk_in',
  TRADE_SHOW: 'trade_show',
  ADVERTISEMENT: 'advertisement',
  COLD_CALL: 'cold_call',
  OTHER: 'other',
};

export const LEAD_SOURCE_LABELS = {
  website: 'Website',
  referral: 'Referral',
  social_media: 'Social Media',
  email: 'Email',
  phone: 'Phone',
  walk_in: 'Walk In',
  trade_show: 'Trade Show',
  advertisement: 'Advertisement',
  cold_call: 'Cold Call',
  other: 'Other',
};

// Project Status
export const PROJECT_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  COMPLETED: 'completed',
  ON_HOLD: 'on_hold',
  CANCELLED: 'cancelled',
};

export const PROJECT_STATUS_LABELS = {
  active: 'Active',
  inactive: 'Inactive',
  completed: 'Completed',
  on_hold: 'On Hold',
  cancelled: 'Cancelled',
};

export const PROJECT_STATUS_COLORS = {
  active: 'success',
  inactive: 'secondary',
  completed: 'primary',
  on_hold: 'warning',
  cancelled: 'danger',
};

// User Roles
export const USER_ROLES = {
  MANAGER: 'manager',
  EMPLOYEE: 'employee',
};

// Pagination
export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

// Date Formats
export const DATE_FORMAT = 'DD/MM/YYYY';
export const DATETIME_FORMAT = 'DD/MM/YYYY HH:mm';
export const TIME_FORMAT = 'HH:mm';

// Local Storage Keys
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  USER: 'user',
  THEME: 'theme',
};

// Theme
export const THEMES = {
  LIGHT: 'light',
  DARK: 'dark',
};

// Activity Types
export const ACTIVITY_TYPES = {
  LOGIN: 'login',
  LOGOUT: 'logout',
  LEAD_CREATED: 'lead_created',
  LEAD_UPDATED: 'lead_updated',
  STATUS_CHANGE: 'status_change',
  CONTACTED: 'contacted',
  NOTE_ADDED: 'note_added',
  DOCUMENT_UPLOADED: 'document_uploaded',
};